var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c("app-sale-type-select", {
            attrs: {
              value: _vm.view.MetaData.NewSaleTypeID || 1,
              label: _vm.$ct("default-sale-type"),
              fancy: "",
              "contact-group-id": _vm.contactGroupId,
            },
            on: {
              input: function ($event) {
                return _vm.setDefaultNewSaleTypeID($event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }